import { DestroyRef, Directive, ElementRef, NgZone, OnDestroy, inject, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FocusMonitor } from '@angular/cdk/a11y';

/**
 * Emette `keyboardFocus` quando l'elemento host riceve il focus DA TASTIERA (Tab),
 * ignorando mouse, touch e focus programmatico. Basata su CDK FocusMonitor.
 * Usata dal filtro griglia per aprire la tendina operatore all'ingresso col Tab senza
 * innescare aperture indesiderate/loop sul refocus programmatico.
 */
@Directive({
  selector: '[siaKeyboardFocus]',
  standalone: true,
})
export class SiaKeyboardFocusDirective implements OnDestroy {
  #el = inject<ElementRef<HTMLElement>>(ElementRef);
  #focusMonitor = inject(FocusMonitor);
  #zone = inject(NgZone);

  /** Emesso solo quando il focus arriva da tastiera (origine 'keyboard'). */
  keyboardFocus = output<void>();

  constructor() {
    this.#focusMonitor
      .monitor(this.#el.nativeElement)
      .pipe(takeUntilDestroyed(inject(DestroyRef)))
      .subscribe((origin) => {
        if (origin === 'keyboard') {
          this.#zone.run(() => this.keyboardFocus.emit());
        }
      });
  }

  ngOnDestroy(): void {
    this.#focusMonitor.stopMonitoring(this.#el.nativeElement);
  }
}
